// Permission registry must mirror the backend definitions exactly.
export const PERMISSIONS = {
  // Customer Management
  CUSTOMER_CREATE: "customer:create", // Create a customer
  CUSTOMER_VIEW: "customer:view", // View customers

  // User Management
  USER_CREATE: "user:create", // Register new user
  USER_DELETE: "user:delete", // Delete/deactivate user
  USER_UPDATE: "user:update", // Update user information
  USER_VIEW_ALL: "user:view_all", // View all users in tenant

  // Role Management
  ROLE_CREATE: "role:create", // Create new role
  ROLE_DELETE: "role:delete", // Delete a role
  ROLE_UPDATE: "role:update", // Edit role permissions
  ROLE_VIEW: "role:view", // View roles list
  ROLE_ASSIGN: "role:assign", // Assign roles to users

  // Projects
  PROJECT_CREATE: "project:create", // Add a new project
  PROJECT_DELETE: "project:delete", // Delete a project
  PROJECT_UPDATE_STATUS: "project:update_status", // Change status of a project
  PROJECT_VIEW_ALL: "project:view_all", // View all projects
  PROJECT_VIEW_ASSIGNED: "project:view_assigned", // View only assigned projects
  PROJECT_ASSIGN_USERS: "project:assign_users", // Assign/reassign users to projects
  INVOICING_VIEW: "invoicing:view",
  INVOICING_MANAGE: "invoicing:manage",

  // Workflow Builder
  WORKFLOW_EXPORT: "workflow:export", // Export workflow JSON
  WORKFLOW_IMPORT: "workflow:import", // Import workflow JSON
  WORKFLOW_MANAGE_VIEW: "workflow_manage:view", // View persisted workflows
  WORKFLOW_MANAGE_CREATE: "workflow_manage:create", // Create persisted workflow
  WORKFLOW_MANAGE_EDIT: "workflow_manage:edit", // Edit persisted workflow
  WORKFLOW_MANAGE_DELETE: "workflow_manage:delete", // Delete persisted workflow
  WORKFLOW_MANAGE_ASSIGN: "workflow_manage:assign", // Assign workflow to run/project

  // Scheduling
  SCHEDULE_VIEW_OWN: "schedule:view_own",
  SCHEDULE_VIEW_ALL: "schedule:view_all",
  SCHEDULE_CONFIGURE_ORG: "schedule:configure_org",
  SCHEDULE_CONFIGURE_USER: "schedule:configure_user",
  SCHEDULE_SET_PRIORITY: "schedule:set_priority",

  // Team Activity
  TEAM_ACTIVITY_VIEW_OWN: "team_activity:view_own",
  TEAM_ACTIVITY_VIEW_PROJECT: "team_activity:view_project",
  TEAM_ACTIVITY_VIEW_ALL: "team_activity:view_all",

  // Workload
  WORKLOAD_VIEW_OWN: "workload:view_own",
  WORKLOAD_VIEW_TEAM: "workload:view_team",
  WORKLOAD_VIEW_ALL: "workload:view_all",

  // Time Logging
  TIME_LOG_VIEW_OWN: "time_log:view_own",
  TIME_LOG_VIEW_ALL: "time_log:view_all",
  TIME_LOG_VIEW_PROJECT: "time_log:view_project",
  TIME_LOG_EDIT: "time_log:edit",

  // Tasks (My Tasks)
  TASK_VIEW: "task:view", // Open My Tasks and work on tasks you can see
  TASK_CREATE: "task:create", // Create tasks and subtasks
  TASK_ASSIGN: "task:assign", // Assign tasks to other people (without it, only to yourself)
  TASK_VIEW_ALL: "task:view_all", // See every task in the company and the team overview
  TASK_DELETE_ANY: "task:delete_any", // Delete tasks created by someone else

  // Manufacturing Module
  MANUFACTURING_VIEW: "manufacturing:view",
  MANUFACTURING_MANAGE: "manufacturing:manage",
  MANUFACTURING_PO_CREATE: "manufacturing:po:create",
  MANUFACTURING_PO_VIEW: "manufacturing:po:view",
  MANUFACTURING_PO_UPDATE: "manufacturing:po:update",
  MANUFACTURING_WORKFLOW_VIEW: "manufacturing:workflow:view",
  MANUFACTURING_WORKFLOW_MANAGE: "manufacturing:workflow:manage",
  MANUFACTURING_STAGE_UPDATE: "manufacturing:stage:update",
  MANUFACTURING_REPORTS_VIEW: "manufacturing:reports:view",
  MANUFACTURING_PARTS_VIEW: "manufacturing:parts:view",
  MANUFACTURING_PARTS_MANAGE: "manufacturing:parts:manage",
  MANUFACTURING_INVENTORY_VIEW: "manufacturing:inventory:view",
  MANUFACTURING_INVENTORY_MANAGE: "manufacturing:inventory:manage",
  MANUFACTURING_ALLOTTED_TASK_VIEW: "manufacturing:allotted_task:view", // See allotted tasks and everyone's responses
  MANUFACTURING_ALLOTTED_TASK_MANAGE: "manufacturing:allotted_task:manage", // Create/edit allotted tasks and pick assignees
  MANUFACTURING_PORTAL_MANAGE: "manufacturing:portal:manage", // Issue, revoke and inspect customer view-only links
  MANUFACTURING_PNL_VIEW: "manufacturing:pnl:view", // See PO profit & loss, selling prices and costs
  MANUFACTURING_PNL_MANAGE: "manufacturing:pnl:manage", // Edit and save PO P&L figures
  MANUFACTURING_ASSET_VIEW: "manufacturing:asset:view", // See machines, warranties, maintenance history, breakdowns and downtime
  MANUFACTURING_ASSET_MANAGE: "manufacturing:asset:manage", // Add/edit machines, warranties, checklists, PM schedules and asset settings
  MANUFACTURING_ASSET_MAINTAIN: "manufacturing:asset:maintain", // Log maintenance, complete PM checklists, acknowledge and resolve breakdowns
  MANUFACTURING_ASSET_BREAKDOWN_REPORT: "manufacturing:asset:breakdown_report", // Report a breakdown, in the app or with /breakdown on chat
};
